/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlaylistDto } from '../../models/create-playlist-dto';
import { PlayListDto } from '../../models/play-list-dto';

export interface PlaylistControllerCreate$Params {
      body: CreatePlaylistDto
}

export function playlistControllerCreate(http: HttpClient, rootUrl: string, params: PlaylistControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayListDto>> {
  const rb = new RequestBuilder(rootUrl, playlistControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayListDto>;
    })
  );
}

playlistControllerCreate.PATH = '/api/playlist';
